/** Служебный пользователь «Общий» клуба (login general или general@<club_id>). */
export function isGeneralUser(u: {
  login?: string | null;
  name?: string | null;
}): boolean {
  const login = (u.login || '').toLowerCase();
  return (
    login === 'general' ||
    login.startsWith('general@') ||
    u.name === 'Общий'
  );
}

/** Пилот / админ / владелец — кому можно назначить полёт. */
export const FLYABLE_ROLES = new Set(['owner', 'admin', 'pilot']);

/** Доля владения — admin/pilot; owner только при is_pilot. */
export function canHaveOwnershipShare(
  role?: string | null,
  isPilot: boolean | null | undefined = true
): boolean {
  const r = (role || '').trim().toLowerCase();
  if (!FLYABLE_ROLES.has(r)) return false;
  if (r === 'owner') return isPilot !== false;
  return true;
}

export function isFlyableMember(u: {
  role?: string | null;
  login?: string | null;
  name?: string | null;
  is_pilot?: boolean | null;
}): boolean {
  if (isGeneralUser(u)) return true;
  return canHaveOwnershipShare(u.role, u.is_pilot);
}

/** Варианты пилота для формы полёта / правки. */
export function flightPilotOptions<
  T extends {
    id: number;
    login?: string | null;
    name?: string | null;
    role?: string | null;
  },
>(
  users: T[],
  opts: { isAdmin: boolean; currentUserId?: number | null }
): T[] {
  const flyable = users.filter(isFlyableMember);
  const generalUser = flyable.find(isGeneralUser);
  const humanPilots = flyable.filter((u) => !isGeneralUser(u));
  const allowGeneral = humanPilots.length >= 2 && Boolean(generalUser);

  if (opts.isAdmin) {
    return allowGeneral ? flyable : humanPilots;
  }

  const self = humanPilots.filter((u) => u.id === opts.currentUserId);
  if (allowGeneral && generalUser) {
    return [...self, generalUser];
  }
  return self;
}

/** Админ правит любой полёт; пилот — только свой. */
export function canEditFlight(
  flightPilotId: number | null | undefined,
  opts: {
    isAdmin: boolean;
    canFlyOrBook?: boolean;
    currentUserId?: number | null;
  }
): boolean {
  if (opts.isAdmin) return true;
  if (opts.canFlyOrBook === false) return false;
  const uid = opts.currentUserId;
  return uid != null && uid > 0 && flightPilotId === uid;
}
